import { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import { Basket } from '@wix/bookings-services-preferences-modal';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { DO_NOT_CARE_STAFF } from '../../constants/constants';
import {
  BookingsQueryParams,
  getUrlQueryParamValue,
  mapBasketToCalendarSelections,
  storeCalendarSelections,
} from '@wix/bookings-catalog-calendar-viewer-utils';
import { CalendarState } from '../../components/BookingCalendar/controller';
import {
  GetBookingsSettingsResponse,
  Strategy,
} from '@wix/ambassador-bookings-v2-bookings-settings/types';
import {
  DisplayTarget,
  PreferenceType,
  calculatePreferencesViewForAppointment,
} from '@wix/bookings-services-preferences-modal/utils';

export const createBasketAndReload = ({
  flowAPI,
  servicesInView,
  serviceVariantsMap,
  reloadWidget,
  businessInfo,
}: {
  flowAPI: ControllerFlowAPI;
  servicesInView: Service[];
  serviceVariantsMap: CalendarState['serviceVariantsMap'];
  reloadWidget: () => Promise<void>;
  businessInfo: GetBookingsSettingsResponse;
}) => {
  const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;
  const { session } = platformAPIs.storage;
  const firstService = servicesInView[0];
  const firstServiceLocation = firstService.locations?.[0];

  const resourceFromQueryParam = getUrlQueryParamValue(
    wixCodeApi,
    BookingsQueryParams.RESOURCE,
  );
  const locationFromQueryParam = getUrlQueryParamValue(
    wixCodeApi,
    BookingsQueryParams.LOCATION,
  );

  const appointmentPreferencesDisplay = calculatePreferencesViewForAppointment({
    service: firstService,
    bookingsSettings: businessInfo.bookingsSettings!,
    experiments: flowAPI.experiments,
    serviceOptionsAndVariants: serviceVariantsMap[firstService.id!],
    isRescheduleFlow: false,
    resourceFromUrl: resourceFromQueryParam,
  });

  const isLocationOnCalendar =
    appointmentPreferencesDisplay?.[PreferenceType.LOCATION] ===
    DisplayTarget.CALENDAR;

  const basket: Basket = {
    location: {
      type: firstServiceLocation?.type!,
      value: isLocationOnCalendar
        ? ''
        : locationFromQueryParam &&
          firstService.locations?.some(
            ({ business }) => business?.id === locationFromQueryParam,
          )
        ? locationFromQueryParam
        : firstServiceLocation?.business?.id ||
          firstServiceLocation?.custom?.address?.formattedAddress! ||
          '',
    },
    selectedServicesPreferences: servicesInView.map((service) => ({
      service,
      resources: {
        staff: service.staffMemberIds?.includes(resourceFromQueryParam)
          ? [resourceFromQueryParam]
          : [],
      },
      variant: serviceVariantsMap[service.id!]?.variants?.values?.[0],
    })),
  };

  const calendarSelections = mapBasketToCalendarSelections(basket);
  storeCalendarSelections({ calendarSelections, session });

  return reloadWidget();
};
